import { render, staticRenderFns } from "./NewFeatureBanner.vue?vue&type=template&id=9a62a79e&scoped=true&"
import script from "./NewFeatureBanner.vue?vue&type=script&lang=js&"
export * from "./NewFeatureBanner.vue?vue&type=script&lang=js&"
import style0 from "./NewFeatureBanner.vue?vue&type=style&index=0&id=9a62a79e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a62a79e",
  null
  
)

export default component.exports